export default __webpack_public_path__ + "static/media/Logo-Medios.ffb2c35f.svg";